<template>
  <VBlock class="wrapper" :direction="Direction.row" :sort="Sort.space_between">
    <VBlock :direction="Direction.row" :sort="Sort.left_center">
      <VCheckBox name="all-checked" :checked="checked" :onChecked="onAllCheck">
        <VSpan class="text" :text="this.checked ? '선택해제' : '모두선택'" :size="14" />
      </VCheckBox>
    </VBlock>
    <VBlock :direction="Direction.row" :sort="Sort.right_center">
      <VButton class="remove-button" :onClick="onAllDelete">
        <VSpan class="text" text="선택 비우기" :size="14" :color="TextColor.black" />
      </VButton>
    </VBlock>
  </VBlock>
</template>

<script>
import VButton from '@/presentationals/v2/components/layouts/atoms/VButton'
import VCheckBox from '@/presentationals/v2/components/layouts/atoms/VCheckBox'
import VSpan, { TextColor } from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'

export default {
  name: 'ListOptions',
  props: {
    checked: {
      type: Boolean,
      required: true
    },
    isEmptySelectProduct: {
      type: Boolean,
      required: true
    },
    isAllSelectProduct: {
      type: Boolean,
      required: true
    },
    onAllCheck: {
      type: Function,
      required: true
    },
    onAllDelete: {
      type: Function,
      required: true
    }
  },
  components: {
    VButton,
    VCheckBox,
    VSpan,
    VBlock
  },
  data() {
    return {
      Direction,
      Sort,
      TextColor
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.wrapper {
  height: 44px;
  padding: 0 16px 0 16px;
  box-sizing: border-box;
  background-color: $background-white;
  border-bottom: 1px solid $light-gray-5;

  .remove-button {
    width: auto;

    .text {
      cursor: pointer;
      letter-spacing: -0.3px;
    }
  }
}
</style>